import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { useLocale } from "../../i18n/LocaleProvider";

const ProjectCard = ({ project }) => {
  const { lang } = useLocale();
  const fm = project.frontmatter;
  return (
    <article className="card h-100">
      <div className="card-body d-flex flex-column">
        <h3 className="h5 card-title">
          <Link
            to={`/${lang}/projects/${project.slug}`}
            className="stretched-link text-decoration-none"
          >
            {fm.title}
          </Link>
        </h3>
        {fm.role && <div className="text-secondary small mb-2">{fm.role}</div>}
        {fm.excerpt && <p className="card-text text-secondary">{fm.excerpt}</p>}
      </div>
    </article>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    frontmatter: PropTypes.shape({
      title: PropTypes.string.isRequired,
      role: PropTypes.string,
      excerpt: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default ProjectCard;
